import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Main = withSafeSuspense(lazy(
  async () => ({ default: (await import('./main')).Main })
))

export const ExternalMain = withSafeSuspense(lazy(
  async () => ({ default: (await import('./external_main')).ExternalMain })
))
